<template>
        <div class="main_container">
			<h3 style="margin-top:25px;">Edit DSP Campaign Tags</h3>
            <hr>
            
            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Advertiser</label>
                <div class="col-sm-7 pr-5">
                    {{ currentAdvertiser.advertiser_name }}
                    
                </div>
			</div>

            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Advertiser ID</label>
                <div class="col-sm-7 pr-5">
                    {{ currentAdvertiser.advertiser_id }}
                    
                </div>
			</div>
            
            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Order</label>
                <div class="col-sm-7 pr-5">
                    {{ currentAdvertiser.name }}
                    
                </div>
			</div>
            
            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Order ID</label>
                <div class="col-sm-7 pr-5">
                    {{ currentAdvertiser.order_id }}
                    
                </div>
			</div>
            
            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Type</label>
                <div class="col-sm-7 pr-5">
                    DSP
                    
                </div>
			</div>

            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Start Date</label>
                <div class="col-sm-7 pr-5">
                    {{ currentAdvertiser.start_date }}
                </div>
			</div>

            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">End Date</label>
                <div class="col-sm-7 pr-5">
                    {{ currentAdvertiser.end_date }}
                </div>
			</div>
            
            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Brand<sup>*</sup></label>
                <div class="col-sm-7 pr-5">
                    <input type="text" placeholder="Brand Tag" v-model="currentAdvertiser.brand_tag" name="title" class="form-control small-input" id="title" >
                    
                </div>
			</div>
            
            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Category<sup>*</sup></label>
                <div class="col-sm-7 pr-5">
                    <input type="text" placeholder="Category Tag" v-model="currentAdvertiser.cat_tag" name="title" class="form-control small-input" id="title" >
                    
                </div>
			</div>
            
            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Tactic 1<sup>*</sup></label>
                <div class="col-sm-7 pr-5">
			<div class="sel_fil_wrap three">
                    <multiselect
					v-model="currentAdvertiser.t1_tag"
					:options="tactic1FilterOptions"
					:show-no-results="true"
					:searchable="true"
					ref="multiselect"
					label="value"
					track-by="value"
					open-direction="bottom"
					:taggable="false"
                    placeholder="Select from dropdown"
					class="form-control multi-dropdown select_filter small-input"
					selectLabel = ""
					selectedLabel = ""
					/>
                    </div>
                    
                </div>
			</div>
            
            <div class="form-group row">
                <label for="advertiser" class="col-sm-2 col-form-label">Tactic 2<sup>*</sup></label>
                <div class="col-sm-7 pr-5">
			<div class="sel_fil_wrap three" >
                    <multiselect
					v-model="currentAdvertiser.t2_tag"
					:options="tactic2FilterOptions"
					:show-no-results="true"
					:searchable="true"
					ref="multiselect"
					label="value"
					track-by="value"
					open-direction="bottom"
					:taggable="false"
                    placeholder="Select from dropdown"
					class="form-control multi-dropdown select_filter small-input"
					selectLabel = ""
					selectedLabel = ""
					/>
                    </div>
                    
                </div>
			</div>
            <button
						type="button"
						class="btn btn-primary"
						@click = "saveOrderTags()"
						data-dismiss="modal"
						>Save changes</button>
                        <span class="returnSuccessMessage">{{ this.serverReturnMessage }}</span>
        </div>
</template>

    <script>
    import Multiselect from "vue-multiselect";


    export default {
        name: "DspAdvertiser",
        components:{
            Multiselect
        },
        mounted() {
            this.serverReturnMessage = ''
            if(this.$store.state.currentDspAdvertiser) {
                this.orderId = this.$store.state.currentDspAdvertiser.order_id
            } else {
                this.orderId = this.$route.params.orderId
                console.log('Loading advertiser from order:',this.orderId)
                const params = {
                    order_id: this.orderId
                }
	            this.$store.dispatch("getAdvertiserFromId",params)
            }
            console.log('Current Order ID',this.orderId,this.currentAdvertiser)
            
        },
        data() {
            return {
                orderId: 0,
                brand:'',
                serverReturnMessageClass:'returnSuccessMessage',
                tactic1FilterOptions:[
                    { name: `Awareness`, value: `Awareness` },
                    { name: `Prospecting`, value: `Prospecting` },
                    { name: `Retargeting`, value: `Retargeting` },
                    { name: `Retention`, value: `Retention` }
                ],
                tactic2FilterOptions:[
                    { name: `Awareness`, value: `Awareness` },
                    { name: `Consideration`, value: `Consideration` },
                    { name: `Conversion`, value: `Conversion` },
                    { name: `Cross-sell`, value: `Cross-sell` },
                    { name: `Loyalty`, value: `Loyalty` },
                    { name: `Prospecting`, value: `Prospecting` },
                    { name: `Purchase`, value: `Purchase` },
                    { name: `Retargeting`, value: `Retargeting` },
                    { name: `Retention`, value: `Retention` },
                    { name: `Trial`, value: `Trial` }
                ],
            }
        },
        computed: {
            currentAdvertiser: {
                set(val) {
                this.$store.state.currentDspAdvertiser = val;
                },
                get() {
                return this.$store.state.currentDspAdvertiser;
                }
            },
            serverReturnMessage: {
                set(val) {
                this.$store.state.serverReturnMessage = val;
                },
                get() {
                return this.$store.state.serverReturnMessage;
                }
            }
        },
        methods: {
            saveOrderTags() {
                let params = {
                    order_id: this.currentAdvertiser.order_id,
                }
                if(this.currentAdvertiser.brand_tag) {
                    params.brand_tag = this.currentAdvertiser.brand_tag
                }
                if(this.currentAdvertiser.cat_tag) {
                    params.cat_tag = this.currentAdvertiser.cat_tag
                }
                if(this.currentAdvertiser.t1_tag && this.currentAdvertiser.t1_tag.value) {
                    params.t1_tag = this.currentAdvertiser.t1_tag.value
                }
                if(this.currentAdvertiser.t2_tag && this.currentAdvertiser.t2_tag.value) {
                    params.t2_tag = this.currentAdvertiser.t2_tag.value
                }
                
                console.log('Saving...', params)
                this.serverReturnMessage = 'Saving...'
                this.serverReturnMessageClass = 'waitingMessage'
	            this.$store.dispatch("saveOrderTags",params)
            }
        }
    }
    </script>
<style>
.col-form-label {
    font-weight: bold;
}
.small-input {
    width:400px;
}
.waitingMessage {
    color: red;
}
.returnSuccessMessage {
    color: green;
}
.main_container {
    min-height: 1200px;
}
</style>